import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/uf?${serialize(filtros)}`)
}
